import React from 'react';
import {Table as ClassicTable} from './classic';
import {Table as SingleGameTable} from './single-game';

const PlayersList = {
    get(sportConfig) {
        if (sportConfig.isGameTypeClassic()) {
            return ClassicTable;
        } else if (sportConfig.isGameTypeSingleGame()) {
            return SingleGameTable;
        }

        throw new Error(`PlayersList ERR: unknown game type ${sportConfig.getGameType()}`);
    },
};

export {PlayersList};
